// import 'date-carousel/date-carousel.js'
const $ = jQuery;
const weekDays = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];
const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
let slickInst = null;
const datesSlick = $('.dates-carousel');
const datePicker = $('.bs-date-pick');
const roomId = $('.ajax_filter_template').data('roomid');
let currentDate = dateToISOString(new Date());
let fillUpSlides;

// fetch chatroom sessions by date
function filter_chatroom_req(date) {
  currentDate = date;
  // hide video when new date is selected
  $('.chatroom_new_exp .video-container').hide();
  $('#accordionChatLog').hide();
  $.ajax({
    url: document.location.origin + '/cms/wp-admin/admin-ajax.php',
    data: {
      action: 'chatRoomByDate',
      date: date,
      room_id: +roomId,
    },
    type: 'POST',
    beforeSend: function (xhr) {
      $('#response').html(
        `<div class="text-center"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>`
      );
    },
    success: function (data) {
      responsiveSlider();
      let result = data;
      if (data[data.length - 1] == 0) {
        result = data.substring(0, data.length - 1);
      }
      if (result) {
        result = JSON.parse(result);
        if (result.videos.length) {
          renderResults(result.videos);
        }

        if (result.chatlog) {
          let chatLogs = JSON.parse(result.chatlog);
          renderChatLogs(chatLogs);
        }
      } else {
        $('#response').html(`
          <div class="text-center" style="padding-top: 40px;">
            <!-- no-video SVG omitted for brevity -->
            <h2 style="margin-top: 20px;">No Video to Display</h2>
          </div>
        `);
      }
    },
    error: function (request, status, error) {
      console.log(error);
    },
  });
  return false;
}

let isOpen = false;
$('.datepicker-wrapper, .more_dates').on('click', function (event) {
  event.stopPropagation();
  isOpen = !isOpen;
  if (isOpen) {
    $('.bs-date-pick').focus();
  } else {
    $('.bs-date-pick').focusout();
  }
});

// click outside of calendar
$(window).click(function () {
  isOpen = false;
});

// bs datepicker init
if (datePicker.length) {
  datePicker.datepicker({
    format: 'yyyy-mm-dd',
    autoclose: true,
    orientation: 'bottom left',
    todayHighlight: true,
    weekStart: 1,
    endDate: new Date(),
  });

  // when calendar date change
  datePicker.datepicker().on('changeDate', function (e) {
    const date = e.target.value;
    datesSlick.slick('removeSlide', null, null, true);
    populateDatesCarousel(slickInst, date);
    filter_chatroom_req(date);
  });
}

// on slider init populate dates
datesSlick.on('init', function (event, slick) {
  slickInst = slick;
  const today = new Date();
  let dateToIso = dateToISOString(today);
  populateDatesCarousel(slick);
  filter_chatroom_req(dateToIso);
});

// on slide change populate new date from the old one
datesSlick.on('afterChange', function (event, slick, currentSlide) {
  const slides = slick.$slides;
  if (currentSlide < 1) {
    const firstDate = slides[0].children[0].dataset.date;
    let yesterday = new Date(firstDate);
    yesterday.setDate(yesterday.getDate() - 1);
    slideTemplate(yesterday, 0, 1);
  }
  if (slides.length - 5 === currentSlide) {
    const lastDate = slides[slides.length - 1].children[0].dataset.date;
    let tomorrow = new Date(lastDate);
    tomorrow.setDate(tomorrow.getDate() + 1);
    slideTemplate(tomorrow);
  }
});

function populateDatesCarousel(slick, selDate) {
  let date = selDate ? new Date(selDate) : new Date();
  let previousDates = [];
  for (let i = 0; i < 10; i++) {
    let previousDate = new Date(date);
    previousDate.setDate(date.getDate() - (i + 1));
    previousDates.push(previousDate);
  }
  let nextDates = [];
  for (let i = 0; i < 10; i++) {
    let nextDate = new Date(date);
    nextDate.setDate(date.getDate() + (i + 1));
    nextDates.push(nextDate);
  }
  const allDates = [...previousDates.reverse(), date, ...nextDates];
  fillUpSlides = setTimeout(() => {
    allDates.map((d) => slideTemplate(d));
    datesSlick.slick('slickGoTo', 8);
    slick.$slides.map((ind, slide) => {
      if (slide.children[0].dataset.date == dateToISOString(date)) {
        $(slide).children().addClass('active_date');
      } else if (slide.children[0].dataset.date > dateToISOString(new Date())) {
        $(slide).children().addClass('disabled');
      }
    });
  }, 1000);
}

// initiate dates carousel
datesSlick.slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  infinite: false,
  prevArrow:
    '<div><svg width="22" height="40" viewBox="0 0 29 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M25.2866 4L2.9999 23.3529L25.2866 44" stroke="#BEBEBE" stroke-width="5" stroke-linecap="square" stroke-linejoin="round"/></svg></div>',
  nextArrow:
    '<div><svg width="22" height="40" viewBox="0 0 30 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.28662 44L26.5733 24.6471L4.28662 4" stroke="#BEBEBE" stroke-width="5" stroke-linecap="square" stroke-linejoin="round"/></svg></div>',
});

// on carousel date click
$('.slick-slider').on('click', '.slick-slide', function () {
  if (!$(this).children().hasClass('disabled')) {
    const date = $(this).children().data('date');
    filter_chatroom_req(date);
    $(this)
      .children()
      .addClass('active_date')
      .parent()
      .siblings()
      .children()
      .removeClass('active_date');
  }
});

// populate dates into slides
function slideTemplate(date, ind, insertBefore) {
  const day = dateToISOString(date).split('-')[2];
  return datesSlick.slick(
    'slickAdd',
    `<div><div class="slide-date" data-date="${dateToISOString(date)}">
      ${weekDays[date.getDay()]}
      <h4><strong>${monthNames[date.getMonth()]} ${+day}</strong></h4>
      </div></div>`,
    ind,
    insertBefore
  );
}

// render session card
function renderResults(result) {
  $('#response').html(
    result.map(
      (card) => `
    <div class="card" data-video="${card.url}" data-img="${card.trader_image}">
      <img src="${card.trader_image}" />
      <div style="padding: 20px;">
        <div>${formatDate(card.timestamp)}</div>
      </div>
    </div>
  `
    )
  );
}

// play video on card click
$('#response').on('click', function (e) {
  if ($(e.target).attr('id') !== 'response') {
    const card = $(e.target).parent();
    if (card.hasClass('card')) {
      const url = 'https://static.simplertrading.com/' + card.data('video');
      const img = card.data('img');
      $(this).find('.card').show();
      card.hide();
      $('.chatroom_new_exp .video-container').show();

      // insert HTML5 video player
      const container = document.getElementById('chatroom-player');
      if (container) {
        container.innerHTML = `
          <video controls width="100%" poster="${img}">
            <source src="${url}" type="video/mp4">
            Your browser does not support HTML5 video.
          </video>
        `;
        const videoEl = container.querySelector('video');
        if (videoEl) {
          videoEl.play();
        }
      }

      scrollToEl('.video-container');
    }
  }
});

// format date to June 07, 2022
function formatDate(date) {
  let d = new Date(date);
  let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
  let mo = new Intl.DateTimeFormat('en', { month: 'long' }).format(d);
  let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
  return `${mo} ${da}, ${ye}`;
}

// scroll to element
function scrollToEl(el) {
  $('html, body').animate(
    {
      scrollTop: $(el).offset().top - 100,
    },
    0
  );
}

function dateToISOString(date) {
  return date.toISOString().split('T')[0];
}

// next day button
$('.next-day').on('click', function () {
  let nextDate = new Date(currentDate);
  nextDate.setDate(nextDate.getDate() + 1);
  filter_chatroom_req(dateToISOString(nextDate));
  datesSlick.slick('slickNext');
  $('.active_date')
    .removeClass('active_date')
    .parent()
    .next()
    .children()
    .addClass('active_date');
  scrollToEl('.archive_date_carousel');
});

// prev day button
$('.prev-day').on('click', function () {
  let prevDate = new Date(currentDate);
  prevDate.setDate(prevDate.getDate() - 1);
  filter_chatroom_req(dateToISOString(prevDate));
  datesSlick.slick('slickPrev');
  $('.active_date')
    .removeClass('active_date')
    .parent()
    .prev()
    .children()
    .addClass('active_date');
  scrollToEl('.archive_date_carousel');
});

// populate chatlogs in accordion
function renderChatLogs(chatLogs) {
  let logArrMerge = [...chatLogs.entries.map((log) => log.logArr)];
  logArrMerge = logArrMerge.flat(1);
  if (logArrMerge && logArrMerge.length) {
    $('#accordionChatLog').show();
    document.querySelector('.accordion-body').scrollTop = 0;
    $('#accordionChatLog .accordion-body').html(
      logArrMerge.map(
        (log) => `
        <div class="py-3 d-flex">
          <div class="chat_avatar">${log.user[0]}</div>
          <div>
            <div><strong>${log.user}</strong> ${
              log.time ? getTimeFromDate(log.time) : ''
            }</div>
            <div class="message">${log.text}</div>
          </div>
        </div>
      `
      )
    );
  }
}

// manage accordion button
$('#accordionChatLog .accordion-button').on('click', function () {
  if ($(this).hasClass('collapsed')) {
    $(this).text('Show Chat Log');
  } else {
    $(this).text('Hide Chat Log');
  }
});

// format time from timestamp
function getTimeFromDate(timestamp) {
  var date = new Date(timestamp);
  return date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
}

$(window).on('resize', function (event) {
  const windowWidth = $(this).width();
  responsiveSlider(windowWidth);
});

$(window).on('load', function (event) {
  const windowWidth = $(this).width();
  responsiveSlider(windowWidth);
});

function responsiveSlider(windowWidth = $(window).width()) {
  if (windowWidth > 768 && windowWidth < 960) {
    datesSlick.slick('slickSetOption', 'slidesToShow', 5, true);
    setTimeout(() => {
      datesSlick.slick('slickGoTo', 8);
    }, 1200);
  }

  if (windowWidth < 768 && windowWidth > 540) {
    datesSlick.slick('slickSetOption', 'slidesToShow', 3, true);
    setTimeout(() => {
      datesSlick.slick('slickGoTo', 9);
    }, 1200);
  }

  if (windowWidth < 540 && windowWidth > 360) {
    datesSlick.slick('slickSetOption', 'slidesToShow', 2, true);
    setTimeout(() => {
      datesSlick.slick('slickGoTo', 10);
    }, 1200);
  }

  if (windowWidth < 360) {
    datesSlick.slick('slickSetOption', 'slidesToShow', 1, true);
    setTimeout(() => {
      datesSlick.slick('slickGoTo', 10);
    }, 1200);
  }
}
